export default __webpack_public_path__ + "static/PeopleEmotions_web-fb602716aa3204d39934e1fa70abd1b8.png";